function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "facebookIconTitle"
}, "Facebook");

var _ref3 = /*#__PURE__*/React.createElement("desc", {
  id: "facebookIconDesc"
}, "Facebook icon");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M29.44,0C13.21,0,0,13.21,0,29.44c0,16.24,13.21,29.45,29.44,29.45c16.24,0,29.45-13.21,29.45-29.45 C58.89,13.21,45.68,0,29.44,0L29.44,0z M36.77,30.48h-4.79v17.08h-7.1V30.48H21.5v-6.03h3.38v-3.9c0-2.79,1.33-7.16,7.16-7.16 l5.26,0.02v5.86h-3.82c-0.63,0-1.51,0.31-1.51,1.64v3.55h5.41L36.77,30.48z M36.77,30.48"
});

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.89 58.89",
    xmlSpace: "preserve",
    "aria-labelledby": "facebookIconTitle facebookIconDesc",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "facebookIconTitle"
  }, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.3044487d.svg";
export { ForwardRef as ReactComponent };